export const SET_UPDATE_AVAILABLE = "SET_UPDATE_AVAILABLE";

export interface ServiceWorkerState {
  hasUpdate: boolean;
}

export interface SetUpdateAvailable {
  type: typeof SET_UPDATE_AVAILABLE;
  payload: boolean;
}

export type ServiceWorkerActionTypes = SetUpdateAvailable;

export const initialState: ServiceWorkerState = {
  hasUpdate: false,
};

// eslint-disable-next-line default-param-last
export default function serviceWorker(state = initialState, action: ServiceWorkerActionTypes): ServiceWorkerState {
  if (action.type === SET_UPDATE_AVAILABLE) {
    return {
      ...state,
      hasUpdate: action.payload,
    };
  }

  return state;
}
